const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  actionIcon: {
    marginRight: theme.spacing(1),
  },
  button: {
    fontWeight: 800,
    '&:hover': {
      backgroundColor: theme.palette.subtitle2Color,
      color: 'white',
    },
  },
  stepper: {
    margin: theme.spacing(1),
    padding: 0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.gainsboro,
    borderRadius: 4,
  },
  step: {
    padding: theme.spacing(2),
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.gainsboro,
  },
  stepConnector: {
    display: 'none',
  },
  stepIcon: {
    borderRadius: '50%',
    height: 40,
    width: 40,
    marginTop: 10,
    marginBottom: 10,
    marginRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepIconActive: {
    backgroundColor: theme.palette.darkBlue,
    color: theme.palette.azure,
  },
  stepIconCompleted: {
    backgroundColor: theme.palette.honeydew,
    color: theme.palette.greenPantone,
  },
  stepLabelText: {
    color: theme.palette.titleTableCell,
  },
  stepLabelTextOptional: {
    color: theme.palette.subtitle2Color,
  },
})
export default styles
